import { Particle, type ParticleOptions } from "../Particle";
import { adjustColor } from "../../utils/color";
import { MovesDown } from "../behaviors/MovesDown";
import { TemperatureNormalization } from "../behaviors/TemperatureNormalization";
import { HeatTransfer } from "../behaviors/HeatTransfer";
import { BurnOut } from "../behaviors/BurnOut";
import { Gunpowder } from "./Gunpowder";
import { ChemicalReaction } from "../behaviors/ChemicalReaction";

export class Charcoal extends Particle {
    static baseColor = 0x2C2C2C; // Dark Grey

    constructor(options: Partial<ParticleOptions> = {}) {
        super({
            name: "Charcoal",
            color: adjustColor(Charcoal.baseColor, 8),
            behaviors: [
                new BurnOut(1900, 0.05), // 在接近最高温时有概率消失，放在 MovesDown 之前以便先判断
                new MovesDown(),
                new ChemicalReaction(['Saltpeter', 'Sulfur'], () => new Gunpowder(), 0.05),
                new HeatTransfer(0.1), // 添加热传导，速率适中
                new TemperatureNormalization(20, 0.01) // 降低冷却速度，让它能保持高温更久，从而有时间传热
            ],
            // props: { isFlammable: true } // 木炭不再可燃
            props: {
                isPowder: true,
                thermalConductivity: 0.8 // 较高的热导率，容易传热
            },
            temperature: 20,
            minTemp: -273,
            maxTemp: 2000,
            ...options
        });
    }
}
